/** ISO 4217 codes agents can set on flight quote confirmations. */
export const QUOTE_CURRENCY_OPTIONS = [
  'USD',
  'PKR',
  'SAR',
  'EUR',
  'GBP',
  'AED',
  'TRY',
  'QAR',
  'OMR',
  'BHD',
  'KWD',
  'INR',
];

const ALIASES = {
  '$': 'USD',
  'US$': 'USD',
  'US DOLLAR': 'USD',
  DOLLAR: 'USD',
  DOLLARS: 'USD',
  EURO: 'EUR',
  EUROS: 'EUR',
  POUND: 'GBP',
  RIAL: 'SAR',
  RUPEES: 'PKR',
  RUPEE: 'PKR',
};

export const normalizeQuoteCurrency = (raw, fallback = 'USD') => {
  if (raw == null || raw === '') return fallback;
  const trimmed = String(raw).trim();
  if (/^[A-Za-z]{3}$/.test(trimmed)) return trimmed.toUpperCase();
  const upper = trimmed.toUpperCase();
  if (QUOTE_CURRENCY_OPTIONS.includes(upper)) return upper;
  const alias = ALIASES[trimmed] || ALIASES[upper];
  if (alias) return alias;
  if (trimmed.length >= 3) return trimmed.slice(0, 3).toUpperCase();
  return fallback;
};

export const formatQuoteAmount = (amount, currency) => {
  const code = normalizeQuoteCurrency(currency, '');
  const num = Number(amount);
  if (Number.isNaN(num)) return '-';
  if (code === 'PKR') return `PKR ${num.toLocaleString()}`;
  if (code) return `${code} ${num.toLocaleString()}`;
  return num.toLocaleString();
};